import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutErrorCodeList extends Layout {
    labelPageTitle: Label;
    panelPageTitle: Panel;
    sourceEdiErrorCode: DataSource;
    tableErrorCode: Table;
}
